var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"9","viewBox":"0 0 9 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6.61.629L.237 7.002l6.373 6.373 1.579-1.579-4.794-4.794 4.794-4.794-1.58-1.58z","fill":"#919DAF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }